import React,{useEffect, useRef} from 'react';
import {data, urlRoot} from '../utils/data';
import { useStateContext } from '../context/stateContext';

const About = () => {
  const {lightTheme} = useStateContext();
  const paragraphRef=useRef(null);
  useEffect(()=>{
      paragraphRef.current.innerHTML=data.about.replace("|SKILLS|", `<a href='#skills'>skills</a>`).replace("|LINKEDIN|", `<a href='https://www.linkedin.com/in/aboubaker-idhamide/' target="_blank">LinkedIn</a>`)
  },[])
  return (
    <section className={`about-section ${lightTheme?"light":"dark"}`} id="about">
      <div className="container">
          <h2 className='main-heading'>
            Abou<span>t</span> Me
          </h2>
          <div className="details">
            <p ref={paragraphRef}></p>
            <div className='image'>
              <img src={`${urlRoot}${data?.image}`} alt="profile-img" />
            </div>
          </div>
      </div>
    </section>
  )
}

export default About
